import axios from 'axios';

const SESSION_STORAGE_KEY = 'spev2_dismiss_approver_session';

export const resolveSupplierApiUrl = () => {
	const hostname = window.location.hostname;
	if (hostname.includes('dev')) return 'https://devsupplier.isupplier-portal.com';
	if (hostname.includes('149')) return 'http://149.129.241.185:31016';
	if (hostname.includes('spb')) return 'https://zsupplier.isupplier-portal.com';
	if (hostname.includes('192.')) return 'http://192.168.74.211:30596';
	return 'http://localhost:8596';
};

export const getDismissApproverSession = () => {
	try {
		const raw = sessionStorage.getItem(SESSION_STORAGE_KEY);
		if (!raw) return null;
		const parsed = JSON.parse(raw);
		if (!parsed?.sessionToken) return null;
		return parsed;
	} catch (_err) {
		return null;
	}
};

export const setDismissApproverSession = (payload) => {
	sessionStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(payload || {}));
};

export const clearDismissApproverSession = () => {
	sessionStorage.removeItem(SESSION_STORAGE_KEY);
};

const withSessionHeader = (sessionToken) => ({
	Authorization: `Bearer ${sessionToken}`,
});

export const authenticateSpeV2DismissApprover = (token, { username, password }) =>
	axios.post(`${resolveSupplierApiUrl()}/spev2/public/dismiss-auth`, {
		token,
		username,
		password,
	});

export const previewSpeV2DismissDecision = (token, sessionToken) =>
	axios.post(
		`${resolveSupplierApiUrl()}/spev2/public/dismiss-preview`,
		{ token },
		{ headers: withSessionHeader(sessionToken) }
	);

/**
 * @param {string} token
 * @param {string} sessionToken
 * @param {{ action: 'approve'|'reject', rejectReason?: string }} payload
 */
export const submitSpeV2DismissDecision = (token, sessionToken, payload = {}) =>
	axios.post(
		`${resolveSupplierApiUrl()}/spev2/public/dismiss-decision`,
		{
			token,
			action: payload.action,
			rejectReason: payload.rejectReason || '',
		},
		{ headers: withSessionHeader(sessionToken) }
	);

export const downloadSpeV2DismissAttachment = (token, sessionToken) =>
	axios.post(
		`${resolveSupplierApiUrl()}/spev2/public/dismiss-attachment`,
		{ token },
		{ headers: withSessionHeader(sessionToken) }
	);

export const downloadSpeV2DismissReportPdf = (token, sessionToken) =>
	axios.post(
		`${resolveSupplierApiUrl()}/spev2/public/dismiss-report-pdf`,
		{ token },
		{ headers: withSessionHeader(sessionToken) }
	);
